{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -125.61193198541402,
              48.14467991755245
            ],
            [
              -94.26945666433262,
              48.999994018638745
            ],
            [
              -83.89378215804861,
              46.241338843409835
            ],
            [
              -82.76303386346753,
              42.20748456210973
            ],
            [
              -70.55044609830487,
              45.276043467285746
            ],
            [
              -68.03256280407591,
              47.575780163027645
            ],
            [
              -66.25726332310855,
              43.194793629485815
            ],
            [
              -44.00385786844629,
              46.950676227443665
            ],
            [
              -31.309900030518577,
              66.09890502009515
            ],
            [
              -16.73746874409096,
              69.96311014838372
            ],
            [
              -0.6134416037064057,
              84.18683226319638
            ],
            [
              -155.40243228553985,
              77.55301251709358
            ],
            [
              -140.58287050235185,
              69.59557526401713
            ],
            [
              -141.13767758353413,
              53.95444434494394
            ],
            [
              -125.61193198541402,
              48.14467991755245
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}